<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <help :text="$t('help.popups')" :title="$t('help.popups_title')"/>

    <filters
      class="white-container"
      v-if="filters"
      :inputs="filters"
      @filter="filter"
      :extendButton="false"
      :extended="true"
      :loading="loading"
    >
    </filters>

    <div class="position-relative">

      <loader v-if="loading"/>

      <v-server-table
        ref="appTable"
        name="templatesTable"
        class="white-container"
        url="/admin/popup-templates"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true">

        <template slot="beforeFilter">

          <b-row>
            <b-col>
              <router-link to="templates/create">
                <b-button
                  class="px-4 mb-3"
                >{{ $t('popup_templates.add_new_template') }}
                </b-button>
              </router-link>
            </b-col>
          </b-row>

        </template>

        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{$t('global.showing')}}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
        </template>
        <template slot="active" slot-scope="props">
          <column-check :row="props.row" column="active"/>
        </template>
        <template slot="created_at" slot-scope="props">
          <column-date :row="props.row" column="created_at" format="L"/>
        </template>
        <template slot="actions" slot-scope="props">
          <column-action
            :deleteUrl="`/popup-templates/${props.row.uid}`"
            @deleteItems="refreshTable('appTable')"
            :route="{path: `/templates/edit/${props.row.uid}`, params: {id: props.row.uid}}"
          />
        </template>
      </v-server-table>
    </div>
  </div>

</template>

<script>
  import axios from '@/utils/axios';
  import {Event} from 'vue-tables-2';
  import templatesFilters from './templatesFilters.js';
  import i18n from "@/utils/i18n";
  import filters from '@/components/global/filters';

  export default {
    middleware: 'auth',
    name: 'Templates',
    components: {
      filters
    },
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        params: {
          page: 1
        },
        columns: ['title', 'name', 'slug', 'active', 'status', 'created_at', 'actions'],
        filters: templatesFilters,
        options: {
          skin: [],
          headings: {
            title: i18n.t('form.title'),
            name: i18n.t('form.name'),
            slug: i18n.t('form.slug'),
            active: i18n.t('form.active'),
            status: i18n.t('form.status'),
            created_at: i18n.t('transactions.date_&_time'),
            actions: i18n.t('button.edit')
          },
          sortable: [],
          dateColumns: ['created_at'],
          columnsDropdown: false,
          filterByColumn: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: {
                filter: data.custom,
                limit: data.limit,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.templatesTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    methods: {
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.templatesTable.filter::custom', params)
      }
    },
    destroyed() {
      Event.$off('vue-tables.templatesTable.loaded');
    }
  }
</script>